import React from 'react';
import styles from './PlanBoxes.module.scss';

export const PersonalPlanBox = () => (
  <div className={styles.personalPlanBox}>
    <span>Pers</span>
  </div>
);

export const ProPlanBox = () => (
  <div className={styles.proPlanBox}>
    <span>Pro</span>
  </div>
);

export const TeamsPlanBox = () => (
  <div className={styles.teamsPlanBox}>
    <span>Teams</span>
  </div>
);
